import React from 'react';
// import MDAvatar from 'components/MDAvatar';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import DirectionsIcon from '@mui/icons-material/Directions';
import DescriptionIcon from '@mui/icons-material/Description';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ScienceIcon from '@mui/icons-material/Science';
import { ClaimsOverviewPage } from 'pages/Claims/ClaimsOverviewPage';
import { PaymentsPage } from 'pages/Finance/PaymentsPage';
import { ProcessPaymentsPage } from 'pages/Finance/ProcessPaymentsPage';
// import { ClaimsDetailsPage } from 'pages/Claims/ClaimsDetailsPage';
import ClaimsPage from 'pages/ClaimsPage';
import { BillsPage } from 'pages/BillsPage';
import { EligibilityOverviewPage } from 'pages/Eligibility/EligibilityOverviewPage';
import ProfilePage from 'pages/ProfilePage';
import SupportPage from 'pages/SupportPage';
import { UB04IngestPage } from 'pages/ManualIngestPage/UB04IngestPage';
import { CMS1500IngestPage } from 'pages/ManualIngestPage/CMS1500IngestPage';
import { ManualIngestOverviewPage } from 'pages/ManualIngestPage/ManualIngestOverviewPage';
import VOBPage from 'pages/VOBPage';
import SteerageOverviewPage from 'pages/SteeragePage/SteerageOverviewPage';
import SteerageDetailsPage from 'pages/SteeragePage/SteerageDetailsPage';
import { ReleaseFormsPage } from 'pages/ReleaseFormsPage';
import { MedicalRecordsPage } from 'pages/MedicalRecordsPage';
import { AutomationPage } from 'pages/AutomationPage';
import { TasksPage } from 'pages/TasksPage';
import { FairFareAI } from 'pages/FairFareAI';
import WhatsAppDemoPage from 'pages/Demo/WhatsAppDemoPage';
// import profilePicture from 'assets/images/team-3.jpg';

// Type definition for route items
type RouteItem = {
  type: string;
  name?: string | React.ReactNode;
  key: string;
  icon?: React.ReactNode;
  route?: string;
  component?: React.ReactNode;
  noCollapse?: boolean;
  collapse?: RouteItem[];
  allowedRoles?: string[]; // Add this property to specify allowed roles
  parentKey?: string; // For nested routes
  featureFlag?: string; // For feature flag controlled routes
};

const FFRoutes: RouteItem[] = [
  // {
  //   type: 'collapse',
  //   name: 'Carrier Area',
  //   key: 'carrier-area',
  //   icon: <MDAvatar src={/** get carrier logo here */} alt="Carrier Logo" size="sm" />,
  //   collapse: [
  //     {
  //       name: 'Account',
  //       key: 'account',
  //       route: '/account',
  //       component: <CarrierAccount />,
  //     },
  //     {
  //       name: 'Card Settings',
  //       key: 'card-settings',
  //       route: '/card-settings',
  //       component: <CardSettings />,
  //     },
  //   ],
  // },
  // { type: 'divider', key: 'divider-0' },
  {
    type: 'ff_item',
    noCollapse: true,
    name: (
      <img
        src="/fairfare-ai-menu-item.png"
        alt="FairFare AI"
        style={{ height: '23px', width: 'auto', display: 'block' }}
      />
    ),
    key: 'fairfare-ai',
    // icon: <SmartToyIcon />,
    component: <FairFareAI />,
    featureFlag: 'ai',
    route: '/ai-chat',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'super_user', 'worker'], // agents work in steerage, not here
  },
  {
    type: 'collapse',
    name: 'Steerage',
    key: 'steerage',
    icon: <DirectionsIcon />,
    route: '/steerage',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'data_reader'], // super_user always sees every item
    collapse: [
      {
        type: 'ff_item',
        name: 'Overview',
        key: 'steerage-overview',
        route: '/steerage/overview',
        component: <SteerageOverviewPage />,
        parentKey: 'steerage',
      },
      {
        type: 'ff_item',
        name: 'Details',
        key: 'steerage-details',
        route: '/steerage/details',
        component: <SteerageDetailsPage />,
        parentKey: 'steerage',
      },
    ],
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Medical Documents',
    key: 'release-forms',
    icon: <DescriptionIcon />,
    component: <ReleaseFormsPage />,
    route: '/release-forms',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'data_reader'],
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Eligibility',
    key: 'eligibility',
    icon: <AssignmentTurnedInIcon />,
    component: <EligibilityOverviewPage />,
    route: '/eligibility',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'super_user', 'data_reader'],
  },
  {
    type: 'collapse',
    name: 'Claims',
    key: 'claims',
    icon: <DashboardOutlinedIcon />,
    route: '/claims',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'data_reader'],
    collapse: [
      {
        type: 'ff_item',
        name: 'Overview',
        key: 'claims-overview',
        route: '/claims/overview',
        component: <ClaimsOverviewPage />,
        parentKey: 'claims',
      },
      {
        type: 'ff_item',
        name: 'Cases',
        key: 'claims-cases',
        route: '/claims/cases',
        component: <ClaimsPage />,
        parentKey: 'claims',
      },
      {
        type: 'ff_item',
        name: 'Bills',
        key: 'claims-bills',
        route: '/claims/bills',
        component: <BillsPage />,
        parentKey: 'claims',
      },
    ],
  },
  {
    type: 'collapse',
    name: 'Finance',
    key: 'finance',
    icon: <AccountBalanceIcon />,
    route: '/finance',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'data_reader'],
    // featureFlag: 'finance', // Only visible when finance feature flag is enabled
    collapse: [
      {
        type: 'ff_item',
        name: 'Payments',
        key: 'finance-payments',
        route: '/finance/payments',
        component: <PaymentsPage />,
        parentKey: 'finance',
      },
      {
        type: 'ff_item',
        name: 'Process Payments',
        key: 'finance-process-payments',
        route: '/finance/process-payments',
        component: <ProcessPaymentsPage />,
        parentKey: 'finance',
        allowedRoles: ['super_user'],
      },
    ],
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Profile',
    key: 'profile',
    icon: <ManageAccountsOutlinedIcon />,
    component: <ProfilePage />,
    route: '/profile',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance'],
  },
  // {
  //   type: 'ff_item',
  //   noCollapse: true,
  //   name: 'Billing',
  //   key: 'billing',
  //   icon: <CreditCardOutlinedIcon />,
  //   component: <PaymentPage />,
  //   route: '/billing',
  //   requiredRole: 'admin',
  // },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Tasks',
    key: 'tasks',
    icon: <AssignmentIcon />,
    component: <TasksPage />,
    route: '/tasks',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance', 'super_user', 'worker', 'customer_support_agent'],
    featureFlag: 'tasks',
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Support',
    key: 'support',
    icon: <SupportAgentOutlinedIcon />,
    component: <SupportPage />,
    route: '/support',
    allowedRoles: ['admin', 'claims_adjudicator', 'finance'],
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'VOB',
    key: 'vob',
    icon: <VerifiedUserOutlinedIcon />,
    component: <VOBPage />,
    route: '/vob',
    allowedRoles: ['customer_support_agent'],
  },
  {
    type: 'ff_item',
    name: 'Logout',
    key: 'logout',
    icon: <ExitToAppOutlinedIcon />,
    route: '/logout',
  },
  {
    type: 'collapse',
    name: 'Manual Ingest',
    key: 'manual-ingest',
    icon: <CloudUploadOutlinedIcon />,
    route: '/manual-ingest',
    component: <ManualIngestOverviewPage />,
    allowedRoles: ['super_user'], // Only visible to super_user
    collapse: [
      {
        type: 'ff_item',
        name: 'UB04 Forms',
        key: 'manual-ingest-ub04',
        route: '/manual-ingest/ub04',
        component: <UB04IngestPage />,
        parentKey: 'manual-ingest',
      },
      {
        type: 'ff_item',
        name: 'CMS-1500 Forms',
        key: 'manual-ingest-cms1500',
        route: '/manual-ingest/cms1500',
        component: <CMS1500IngestPage />,
        parentKey: 'manual-ingest',
      },
    ],
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Medical Records Update',
    key: 'medical-records',
    icon: <MedicalInformationIcon />,
    component: <MedicalRecordsPage />,
    route: '/medical-records',
    allowedRoles: ['super_user'], // Only visible to super_user
  },
  {
    type: 'ff_item',
    noCollapse: true,
    name: 'Automation',
    key: 'automation',
    icon: <SmartToyIcon />,
    component: <AutomationPage />,
    route: '/automation',
    featureFlag: 'automation', // Only visible when automation feature flag is enabled
    allowedRoles: ['admin', 'claims_adjudicator', 'finance'],
  },
  {
    type: 'collapse',
    name: 'Demo',
    key: 'demo',
    icon: <ScienceIcon />,
    route: '/demo',
    allowedRoles: ['super_user'],
    collapse: [
      {
        type: 'ff_item',
        name: 'WhatsApp',
        key: 'demo-whatsapp',
        route: '/demo/whatsapp',
        component: <WhatsAppDemoPage />,
        parentKey: 'demo',
        allowedRoles: ['super_user'],
      },
    ],
  },
  // {
  //   type: 'collapse',
  //   name: 'Dashboards',
  //   key: 'dashboards',
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   collapse: [
  //     {
  //       name: 'Analytics',
  //       key: 'analytics',
  //       route: '/dashboards/analytics',
  //       component: <Analytics />,
  //     },
  //     {
  //       name: 'Sales',
  //       key: 'sales',
  //       route: '/dashboards/sales',
  //       component: <Sales />,
  //     },
  //   ],
  // },
  // { type: 'title', title: 'Pages', key: 'title-pages' },
  // {
  //   type: 'collapse',
  //   name: 'Pages',
  //   key: 'pages',
  //   icon: <Icon fontSize="small">image</Icon>,
  //   collapse: [
  //     {
  //       name: 'Projects',
  //       key: 'projects',
  //       collapse: [
  //         {
  //           name: 'Timeline',
  //           key: 'timeline',
  //           route: '/pages/projects/timeline',
  //           component: <Timeline />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Pricing Page',
  //       key: 'pricing-page',
  //       route: '/pages/pricing-page',
  //       component: <PricingPage />,
  //     },
  //     { name: 'RTL', key: 'rtl', route: '/pages/rtl', component: <RTL /> },
  //     {
  //       name: 'Widgets',
  //       key: 'widgets',
  //       route: '/pages/widgets',
  //       component: <Widgets />,
  //     },
  //     {
  //       name: 'Charts',
  //       key: 'charts',
  //       route: '/pages/charts',
  //       component: <Charts />,
  //     },
  //     {
  //       name: 'Notfications',
  //       key: 'notifications',
  //       route: '/pages/notifications',
  //       component: <Notifications />,
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Account',
  //   key: 'account',
  //   icon: <Icon fontSize="small">person</Icon>,
  //   collapse: [
  //     {
  //       name: 'Settings',
  //       key: 'settings',
  //       route: '/pages/account/settings',
  //       component: <Settings />,
  //     },
  //     {
  //       name: 'Billing',
  //       key: 'billing',
  //       route: '/pages/account/billing',
  //       component: <Billing />,
  //     },
  //     {
  //       name: 'Invoice',
  //       key: 'invoice',
  //       route: '/pages/account/invoice',
  //       component: <Invoice />,
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Team',
  //   key: 'team',
  //   icon: <Icon fontSize="small">people</Icon>,
  //   collapse: [
  //     {
  //       name: 'All Projects',
  //       key: 'all-projects',
  //       route: '/pages/profile/all-projects',
  //       component: <AllProjects />,
  //     },
  //     {
  //       name: 'New User',
  //       key: 'new-user',
  //       route: '/pages/users/new-user',
  //       component: <NewUser />,
  //     },
  //     {
  //       name: 'Profile Overview',
  //       key: 'profile-overview',
  //       route: '/pages/profile/profile-overview',
  //       component: <ProfileOverview />,
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Applications',
  //   key: 'applications',
  //   icon: <Icon fontSize="small">apps</Icon>,
  //   collapse: [
  //     {
  //       name: 'Kanban',
  //       key: 'kanban',
  //       route: '/applications/kanban',
  //       component: <Kanban />,
  //     },
  //     {
  //       name: 'Wizard',
  //       key: 'wizard',
  //       route: '/applications/wizard',
  //       component: <Wizard />,
  //     },
  //     {
  //       name: 'Data Tables',
  //       key: 'data-tables',
  //       route: '/applications/data-tables',
  //       component: <DataTables />,
  //     },
  //     {
  //       name: 'Calendar',
  //       key: 'calendar',
  //       route: '/applications/calendar',
  //       component: <Calendar />,
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Ecommerce',
  //   key: 'ecommerce',
  //   icon: <Icon fontSize="small">shopping_basket</Icon>,
  //   collapse: [
  //     {
  //       name: 'Products',
  //       key: 'products',
  //       collapse: [
  //         {
  //           name: 'New Product',
  //           key: 'new-product',
  //           route: '/ecommerce/products/new-product',
  //           component: <NewProduct />,
  //         },
  //         {
  //           name: 'Edit Product',
  //           key: 'edit-product',
  //           route: '/ecommerce/products/edit-product',
  //           component: <EditProduct />,
  //         },
  //         {
  //           name: 'Product Page',
  //           key: 'product-page',
  //           route: '/ecommerce/products/product-page',
  //           component: <ProductPage />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Orders',
  //       key: 'orders',
  //       collapse: [
  //         {
  //           name: 'Order List',
  //           key: 'order-list',
  //           route: '/ecommerce/orders/order-list',
  //           component: <OrderList />,
  //         },
  //         {
  //           name: 'Order Details',
  //           key: 'order-details',
  //           route: '/ecommerce/orders/order-details',
  //           component: <OrderDetails />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Authentication',
  //   key: 'authentication',
  //   icon: <Icon fontSize="small">content_paste</Icon>,
  //   collapse: [
  //     {
  //       name: 'Sign In',
  //       key: 'sign-in',
  //       collapse: [
  //         {
  //           name: 'Basic',
  //           key: 'basic',
  //           route: '/authentication/sign-in/basic',
  //           component: <SignInBasic />,
  //         },
  //         {
  //           name: 'Cover',
  //           key: 'cover',
  //           route: '/authentication/sign-in/cover',
  //           component: <SignInCover />,
  //         },
  //         {
  //           name: 'Illustration',
  //           key: 'illustration',
  //           route: '/authentication/sign-in/illustration',
  //           component: <SignInIllustration />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Sign Up',
  //       key: 'sign-up',
  //       collapse: [
  //         {
  //           name: 'Cover',
  //           key: 'cover',
  //           route: '/authentication/sign-up/cover',
  //           component: <SignUpCover />,
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Reset Password',
  //       key: 'reset-password',
  //       collapse: [
  //         {
  //           name: 'Cover',
  //           key: 'cover',
  //           route: '/authentication/reset-password/cover',
  //           component: <ResetCover />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // { type: 'divider', key: 'divider-1' },
  // { type: 'title', title: 'Docs', key: 'title-docs' },
  // {
  //   type: 'collapse',
  //   name: 'Basic',
  //   key: 'basic',
  //   icon: <Icon fontSize="small">upcoming</Icon>,
  //   collapse: [
  //     {
  //       name: 'Getting Started',
  //       key: 'getting-started',
  //       collapse: [
  //         {
  //           name: 'Overview',
  //           key: 'overview',
  //           href: 'https://www.creative-tim.com/learning-lab/react/overview/material-dashboard/',
  //         },
  //         {
  //           name: 'License',
  //           key: 'license',
  //           href: 'https://www.creative-tim.com/learning-lab/react/license/material-dashboard/',
  //         },
  //         {
  //           name: 'Quick Start',
  //           key: 'quick-start',
  //           href: 'https://www.creative-tim.com/learning-lab/react/quick-start/material-dashboard/',
  //         },
  //         {
  //           name: 'Build Tools',
  //           key: 'build-tools',
  //           href: 'https://www.creative-tim.com/learning-lab/react/build-tools/material-dashboard/',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Foundation',
  //       key: 'foundation',
  //       collapse: [
  //         {
  //           name: 'Colors',
  //           key: 'colors',
  //           href: 'https://www.creative-tim.com/learning-lab/react/colors/material-dashboard/',
  //         },
  //         {
  //           name: 'Grid',
  //           key: 'grid',
  //           href: 'https://www.creative-tim.com/learning-lab/react/grid/material-dashboard/',
  //         },
  //         {
  //           name: 'Typography',
  //           key: 'base-typography',
  //           href: 'https://www.creative-tim.com/learning-lab/react/base-typography/material-dashboard/',
  //         },
  //         {
  //           name: 'Borders',
  //           key: 'borders',
  //           href: 'https://www.creative-tim.com/learning-lab/react/borders/material-dashboard/',
  //         },
  //         {
  //           name: 'Box Shadows',
  //           key: 'box-shadows',
  //           href: 'https://www.creative-tim.com/learning-lab/react/box-shadows/material-dashboard/',
  //         },
  //         {
  //           name: 'Functions',
  //           key: 'functions',
  //           href: 'https://www.creative-tim.com/learning-lab/react/functions/material-dashboard/',
  //         },
  //         {
  //           name: 'Routing System',
  //           key: 'routing-system',
  //           href: 'https://www.creative-tim.com/learning-lab/react/routing-system/material-dashboard/',
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Components',
  //   key: 'components',
  //   icon: <Icon fontSize="small">view_in_ar</Icon>,
  //   collapse: [
  //     {
  //       name: 'Alerts',
  //       key: 'alerts',
  //       href: 'https://www.creative-tim.com/learning-lab/react/alerts/material-dashboard/',
  //     },
  //     {
  //       name: 'Avatar',
  //       key: 'avatar',
  //       href: 'https://www.creative-tim.com/learning-lab/react/avatar/material-dashboard/',
  //     },
  //     {
  //       name: 'Badge',
  //       key: 'badge',
  //       href: 'https://www.creative-tim.com/learning-lab/react/badge/material-dashboard/',
  //     },
  //     {
  //       name: 'Badge Dot',
  //       key: 'badge-dot',
  //       href: 'https://www.creative-tim.com/learning-lab/react/badge-dot/material-dashboard/',
  //     },
  //     {
  //       name: 'Box',
  //       key: 'box',
  //       href: 'https://www.creative-tim.com/learning-lab/react/box/material-dashboard/',
  //     },
  //     {
  //       name: 'Buttons',
  //       key: 'buttons',
  //       href: 'https://www.creative-tim.com/learning-lab/react/buttons/material-dashboard/',
  //     },
  //     {
  //       name: 'Date Picker',
  //       key: 'date-picker',
  //       href: 'https://www.creative-tim.com/learning-lab/react/datepicker/material-dashboard/',
  //     },
  //     {
  //       name: 'Dropzone',
  //       key: 'dropzone',
  //       href: 'https://www.creative-tim.com/learning-lab/react/dropzone/material-dashboard/',
  //     },
  //     {
  //       name: 'Editor',
  //       key: 'editor',
  //       href: 'https://www.creative-tim.com/learning-lab/react/quill/material-dashboard/',
  //     },
  //     {
  //       name: 'Input',
  //       key: 'input',
  //       href: 'https://www.creative-tim.com/learning-lab/react/input/material-dashboard/',
  //     },
  //     {
  //       name: 'Pagination',
  //       key: 'pagination',
  //       href: 'https://www.creative-tim.com/learning-lab/react/pagination/material-dashboard/',
  //     },
  //     {
  //       name: 'Progress',
  //       key: 'progress',
  //       href: 'https://www.creative-tim.com/learning-lab/react/progress/material-dashboard/',
  //     },
  //     {
  //       name: 'Snackbar',
  //       key: 'snackbar',
  //       href: 'https://www.creative-tim.com/learning-lab/react/snackbar/material-dashboard/',
  //     },
  //     {
  //       name: 'Social Button',
  //       key: 'social-button',
  //       href: 'https://www.creative-tim.com/learning-lab/react/social-buttons/material-dashboard/',
  //     },
  //     {
  //       name: 'Typography',
  //       key: 'typography',
  //       href: 'https://www.creative-tim.com/learning-lab/react/typography/material-dashboard/',
  //     },
  //   ],
  // },
  // {
  //   type: 'collapse',
  //   name: 'Change Log',
  //   key: 'changelog',
  //   href: 'https://github.com/creativetimofficial/ct-material-dashboard-pro-react/blob/main/CHANGELOG.md',
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   noCollapse: true,
  // },
];

const allCollapseNames = FFRoutes.filter((route) => route.collapse)
  .map((x) => x.collapse)
  .flat()
  .map((route) => ({
    path: route?.route,
    key: route?.key,
    parentKey: route?.parentKey,
  }));
const FFAvailablePath = [
  ...FFRoutes.map((route) => ({
    path: route.route,
    key: route.key,
    parentKey: route.parentKey,
  })),
  ...allCollapseNames,
];

export { FFRoutes, FFAvailablePath };
